var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-full"},[_c('div',{staticClass:"table-full__container"},[(_vm.isCup)?_c('TableMundial',{attrs:{"custom":_vm.colorsConfig,"seasonget":_vm.numberSeasonId,"await-for-season":"","is-single-component":""}}):_c('Table',{attrs:{"season":_vm.numberSeasonId,"custom":_vm.colorsConfig,"is-single-component":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }